import { useState } from "react";
import { Img, DemoAction, Chip } from "./shared";

const OBJ = [
  { k: "villa1", t: "Villa mit Pool", typ: "Kauf", z: 6, m: 240, ort: "Stadtrand" },
  { k: "estate2", t: "Loft mit Bogenfenstern", typ: "Miete", z: 3, m: 118, ort: "Innenstadt" },
  { k: "villa2", t: "Flachdachhaus", typ: "Kauf", z: 5, m: 210, ort: "Seenähe" },
  { k: "estate1", t: "Gartenwohnung", typ: "Miete", z: 4, m: 96, ort: "Grünlage" },
];

export default function Immobilien({ wide, onCta }) {
  const [f, setF] = useState("Alle");
  const list = OBJ.filter((o) => f === "Alle" || o.typ === f);
  return (
    <div className="bg-[#F7F7F5] text-[#1D2327]" style={{ fontFamily: "'Jost Variable', sans-serif" }}>
      <header className="flex items-center justify-between bg-white px-5 pt-12 pb-4" style={wide ? { paddingTop: 22, paddingLeft: 48, paddingRight: 48 } : undefined}>
        <span className="text-[17px] font-medium tracking-wide">NORDLICHT<span className="font-light text-[#5B7083]"> Immobilien</span></span>
        <span className="text-[12px] text-[#5B7083]">Objekte · Bewerten · Kontakt</span>
      </header>
      <section className="relative">
        <div className={wide ? "h-[440px]" : "h-[300px]"}><Img k="estate1" alt="Wohnraum" /></div>
        <div className={`absolute bg-white p-5 shadow-xl ${wide ? "bottom-10 left-12 w-[420px]" : "bottom-[-40px] left-5 right-5"}`}>
          <p className="text-[11px] uppercase tracking-[0.2em] text-[#5B7083]">Exposé der Woche</p>
          <h1 className={`mt-1 font-light leading-tight ${wide ? "text-[34px]" : "text-[26px]"}`}>Wohnen mit Weitblick.</h1>
          <p className="mt-2 text-[13px] text-[#5B7083]">Fiktive Beispielobjekte einer Designstudie.</p>
        </div>
      </section>
      <section className={wide ? "px-12 py-14" : "px-5 pb-10 pt-16"}>
        <div className="flex items-center justify-between">
          <h2 className="text-[22px] font-light">Aktuelle Objekte</h2>
          <span className="text-[12px] text-[#5B7083]">{list.length} Treffer</span>
        </div>
        <div className="mt-4 flex gap-2">
          {["Alle", "Kauf", "Miete"].map((x) => (
            <Chip key={x} active={f === x} onClick={() => setF(x)} activeCls="bg-[#1D2327] text-white" idleCls="bg-white text-[#1D2327] border border-[#D5D9DC]" className="rounded-sm px-4 py-2 text-[13px]">{x}</Chip>
          ))}
        </div>
        <div className={`mt-5 grid gap-5 ${wide ? "grid-cols-2" : "grid-cols-1"}`}>
          {list.map((o) => (
            <article key={o.t} className="bg-white">
              <div className="relative aspect-[16/10] overflow-hidden">
                <Img k={o.k} alt={o.t} />
                <span className="absolute left-3 top-3 bg-white px-2 py-1 text-[11px] uppercase tracking-wider">{o.typ}</span>
              </div>
              <div className="p-4">
                <h3 className="text-[18px]">{o.t}</h3>
                <p className="mt-1 flex gap-4 text-[13px] text-[#5B7083]"><span>{o.z} Zimmer</span><span>{o.m} m²</span><span>{o.ort}</span></p>
                <DemoAction label="Exposé anfordern" onCta={onCta} className="mt-3 text-[13px] font-medium text-[#1D2327] underline underline-offset-4" />
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
